// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, of, BehaviorSubject } from 'rxjs';

// --- HS Code
import { ProfileBaseService } from './profile-base.service';
import { DemographicValueModel, UserProfileModel, UserDetailsModel, EmailAddressValidationModel } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class ProfileMockService extends ProfileBaseService {

  constructor() {
    super();
  }

  loadProfile(): void {
    const model = {
        firstName: 'Richard',
        lastName: 'Chown',
        emailAddress: 'frikkie@frikadel.com'
    } as UserDetailsModel;
    this._userDetails$.next(model);
    this._isLoaded = true;
  }

  update(
    userDetails: UserProfileModel
  ): Observable<boolean> {
    this._userDetails$.next(null);
    return of (true);
  }

  updateUserDetails(userDetails: UserDetailsModel): void {
    this._userDetails$.next(userDetails);
  }

  updateLoginDetails(loginDetails: UserDetailsModel): void {
    this._userDetails$.next(loginDetails);
  }

  checkIfEmailAddressInUse(emailAddress: string): void {
    this._isEmailAddressInUse$.next({
      emailAddressExists: false,
      isEmailAddressValidated: true,
      isValidEmailAddress: true
    } as EmailAddressValidationModel)
  }
}
